module.exports = __webpack_public_path__ + "static/card-87de787431c1eed69c86c138bd01402a.jpg";